<template>
  <div class="pickr-wrapper">
    <div class="pickr-wrap">
      <template v-if="dateProps.start">
        <!-- <input type="text" class="dateSelector start" placeholder="날짜를 선택하세요." /> -->
        <flat-pickr class="dateSelector" v-model="date.start" @on-change="setStartDate" placeholder="날짜를 선택하세요" :config="startConfig" />
      </template>
      <template v-if="dateProps.end">
        <span>~</span>
        <!-- <input type="text" class="dateSelector end" placeholder="날짜를 선택하세요." /> -->
        <flat-pickr class="dateSelector" v-model="date.end" @on-change="setEndDate" placeholder="날짜를 선택하세요" :config="endConfig" />
      </template>
    </div>
    <!-- <template v-if="dateProps.start && dateProps.end">
      <div class="date-range-selector-container">
      <div class="range-selector-wrap" v-for="(range, index) in dateRange" :key="range">
        <input type="radio" :id="`dateSelector${index}`" name="date-selector" :value="range.value" @click="inputBtnDate" :checked="range.checked" />
        <label :for="`dateSelector${index}`">{{ range.text }}</label>
      </div>
    </div>
    </template> -->
  </div>
</template>
<script>
// import flatpickr from "flatpickr";
import flatPickr from "vue-flatpickr-component";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import "flatpickr/dist/flatpickr.css";

export default {
  name: "DatePicker",
  components: {
    flatPickr
  },
  props: {
    dateProps: {
      type: Object,
      default: {
        start: true,
        end: true
      }
    },
    startDefault:{
      type:Date,
      defalut:new Date()
    },
    endDefault:{
      type:Date,
      defalut:new Date()
    },
    configs:{
      type:Object,
      defalut:{
        enableTime:false,
        dateFormat:"Y-m-d"
      }
    }
  },
  data() {
    return {
      datepickr: "",
      date: {},
      startConfig: {
        // wrap: true, // set wrap to true only when using 'input-group'
        // altInput: true,
        time_24hr: true,
        enableTime: false,
        dateFormat: "Y-m-d",
        locale: Korean,
        defaultDate:this.startDefault
      },
      endConfig: {
        time_24hr: true,
        enableTime: false,
        dateFormat: "Y-m-d",
        locale: Korean,
        defaultDate:this.endDefault
      },
      selectedRange: "",
      dateRange: [
        {
          name: "today",
          text: "오늘",
          value: 0
        },
        {
          name: "aweek",
          text: "1주",
          value: 6
        },
        {
          name: "weeks",
          text: "2주",
          value: 13
        },
        {
          name: "amonth",
          text: "한달",
          value: 30
        }
      ]
    };
  },
  created() {
    // console.log(this.startDefault)
    // console.log(this.endDefault)
    // this.setDefalutDate();
    this.setConfigs();
  },
  methods: {
    maxDate() {
      const today = new Date();
      today.setHours(24, 0, 0);
      return today;
    },
    setStartDate(date) {
      this.$emit("setStartDate", date);
    },
    setEndDate(date) {
      // console.log('kk')
      this.$emit("setEndDate", date);
    },
    setConfigs(){
      if(this.configs){
        this.startConfig.enableTime = this.configs.enableTime;
        this.startConfig.dateFormat = this.configs.dateFormat;
        this.endConfig.enableTime = this.configs.enableTime;
        this.endConfig.dateFormat = this.configs.dateFormat;
        if(this.configs.maxDate){
          this.startConfig.maxDate = this.configs.maxDate;
          this.endConfig.maxDate = this.configs.maxDate;
        }

      }
    },
    // createDatePicker() {
    //   const setStartDate = this.setStartDate;
    //   const setEndDate = this.setEndDate;
    //   const maxDate = () => {
    //     const today = new Date();
    //     today.setHours(24, 0, 0);
    //     return today;
    //   };
    //   const config = {
    //     dateFormat: "Y-m-d",
    //     // time_24hr: true,
    //     enableTime: false,
    //     locale: korean,
    //     disableMobile: "true",
    //     maxDate: maxDate(),
    //     onChange(selectedDate, dateStr, instance) {
    //       const target = instance.element;
    //       if (target.classList.contains("start")) {
    //         setStartDate(selectedDate);
    //       } else {
    //         setEndDate(selectedDate);
    //       }
    //     }
    //   };
    //   this.datepickr = flatpickr(".dateSelector", config);
    //   if (Array.isArray(this.datepickr)) {
    //     for (const pickr of this.datepickr) {
    //       const classList = pickr.config.altInputClass;
    //       if (classList.indexOf("start") !== -1) {
    //         pickr.setDate(this.date.start);
    //       } else {
    //         pickr.setDate(this.date.end);
    //       }
    //     }
    //   }
    // },
    setDefalutDate() {
      if (!this.propDate) {
        this.date.start = new Date();
        this.date.start.setHours(0, 0, 0);
        this.date.end = new Date();
        this.date.end.setHours(23,59,59);
      } else {
        // this.date.start = new Date()
        // this.date.start.setDate(this.date.start-2)
        // this.date.start.setHours(0, 0, 0)
        // this.date.end = new Date()
      }
    },
    inputBtnDate(e) {
      const target = e.target;
      const selectedDays = target.value;
      const start = new Date();
      const end = new Date();
      if (this.selectedRange === target) {
        target.checked = false;
        start.setHours(0, 0, 0);
        this.selectedRange = "";
      } else {
        start.setDate(start.getDate() - selectedDays);
        start.setHours(0, 0, 0);
        this.selectedRange = target;
      }
      for (const pickr of this.datepickr) {
        let setDate;
        const pickrClass = pickr.config.altInputClass;
        if (pickrClass.indexOf("start") !== -1) {
          setDate = start;
        } else {
          setDate = end;
        }
        pickr.setDate(setDate);
      }
    }
  }
};
</script>

<style scoped>
.pickr-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pickr-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}
.pickr-wrap > span {
  font-weight: 800;
  font-size: 19px;
  margin: 0 5px;
}

.dateSelector {
  width: 120px !important;
  height: 30px;
  text-align: center;
  margin: 0 !important;
}

.date-range-selector-container {
  display: flex;
  align-items: center;
  margin-left: 4px;
}

.range-selector-wrap {
  display: flex;
}
.range-selector-wrap > input {
  display: none;
}
.range-selector-wrap > input + label {
  box-sizing: border-box;
  background: #6ab0f3;
  padding: 6px 6px;
  font-weight: 700;
  color: #fff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  margin-right: 4px;
  font-size: 12px;
}
.range-selector-wrap > input:checked + label {
  background: #620000;
}
.range-selector-wrap:last-child > input + label {
  margin-right: 0;
}
</style>
